function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.085 2H4a2 2 0 00-2 2v9a2 2 0 002 2h3v2H5.5a.5.5 0 000 1h9a.5.5 0 000-1H13v-2h3a2 2 0 002-2V7h-1v6a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h10v-.5c0-.175.03-.344.085-.5zM12 17H8v-2h4v2zm3-14.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5V5h-.78a.5.5 0 00-.474.342l-.544 1.632A1.5 1.5 0 0111.78 8H11v1.5a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h3a.5.5 0 01.5.5V7h.78a.5.5 0 00.474-.342l.544-1.632A1.5 1.5 0 0114.22 4H15V2.5zM10 7H8v2h2V7zm6-2h2V3h-2v2z",
  fill: "#6264A7"
});

function SvgLifecyclePowerautomateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgLifecyclePowerautomateIcon;